require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-vb-1-eb.json") })
        }
      }, "path---photos-professional-vb-1-eb");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-vb-1-eb!./.cache/json/photos-professional-vb-1-eb.json
// module id = 932
// module chunks = 231608221292675